import { Property } from '../../../Graphql/Generated/graphql';
import './DisplayListings.css';
import ListingCard from './ListingCard';

interface IPropsDisplayListings {
  properties: Property[];
}

const DisplayListings = (props: IPropsDisplayListings) => {
  return (
    <div>
      <div className='listingBody'>
        {props.properties.map((place: Property) => {
          return <ListingCard key={place.id} place={place} />;
        })}
      </div>
    </div>
  );
};

export default DisplayListings;
